"use strict";
// import * as fs from "fs"
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * レコメンドのID
 * 追加時noticeRepository.init 変更
 */
exports.NOTICE_TYPE = {
    /** 仕入先ランク */
    SupplierRank: 10001,
    /** 得意先ランク */
    ClientRank: 10002,
    /** 担当者ランク */
    StaffRank: 10003,
    /** 受注状況 */
    OrderState: 10004,
    /** 納品状況 */
    DeliveryState: 10005,
    /** 滞留債権 */
    PastDue: 10006,
    /** 部門サマリ情報 */
    SummaryGroup: 10007,
    /** 資格サマリ情報 */
    SummaryQualification: 10008,
    /** 退職サマリ情報 */
    SummaryRetire: 10009,
    /** 社員サマリ情報 */
    SummaryPerson: 10010,
    /** 関連商品 */
    RelatedItem: 20001,
    /** 納期状況 */
    TimeOfDelivery: 20002,
    /** 一定回数受注商品 */
    SomeTimesItem: 20003,
    /** 定期受注商品 */
    IntervalItem: 20004,
    /** 時期受注商品 */
    SeasonItem: 20005,
    /** 類似得意先（商品） */
    SimilarItem: 20006,
    /** 類似得意先（商品区分） */
    SimilarItem2: 20007,
    /** 新着商品 */
    NewItem: 20008,
    /** 新規得意先 */
    NewClient: 20009,
    /** 新規仕入先 */
    NewSupplier: 20010,
    /** 休眠顧客 */
    DormantClient: 20011,
    /** 滞留在庫 */
    RetainedStock: 30001,
    /** 在庫状況（受注商品） */
    StockState: 30002,
    /** 在庫状況（商品） */
    StockState2: 30003,
    /** 在庫状況（商品区分） */
    StockState3: 30004,
    /** 時期発注商品 */
    SeasonOrder: 30005,
    /** 入荷状況 */
    ArrivalState: 30006,
    /** 減少在庫 */
    SafetyStock: 30007,
    // 労務
    /** 滞留社員 */
    PersonalStay: 40001,
    /** 研修受講実績 */
    Training: 40002,
    /** 研修未受講者 */
    Training2: 40003,
    /** 健康診断 */
    HealthCheck: 40004,
    /** 年齢 */
    Age: 40005,
    /** 資格更新 */
    Qualification: 40006,
    /** 退職管理 */
    Retire: 40007,
    /** 労働契約更新 */
    WorkContract: 40008,
    /** 休職者 */
    Leave: 40009,
    /** ビザ・パスポート管理 */
    Passport: 40010,
    /** 家族年齢 */
    Family: 40011,
    /** 出向履歴情報 */
    SecondedTo: 40012,
    /** 出向受入履歴情報 */
    SecondedFrom: 40013,
    /** 社員情報変更通知 */
    // ChangePersonalData: 40014,
    /** 自由通知 */
    Free: 90001,
};
/** レコメンドの名前
 *  括弧を使う場合は全角括弧を使用
 */
exports.NOTICE_NAME = {
    SupplierRank: "仕入先ランク",
    ClientRank: "得意先ランク",
    StaffRank: "担当者ランク",
    OrderState: "受注状況",
    DeliveryState: "納品状況",
    PastDue: "滞留債権",
    RelatedItem: "関連商品",
    TimeOfDelivery: "納期状況",
    SomeTimesItem: "一定回数受注商品",
    IntervalItem: "定期受注商品",
    SeasonItem: "時期受注商品",
    SimilarItem: "類似得意先（商品）",
    SimilarItem2: "類似得意先（商品区分）",
    NewItem: "新着商品",
    NewClient: "新規得意先",
    NewSupplier: "新規仕入先",
    DormantClient: "休眠顧客",
    RetainedStock: "滞留在庫",
    StockState: "在庫状況（受注商品）",
    StockState2: "在庫状況（商品）",
    StockState3: "在庫状況（商品区分）",
    SeasonOrder: "時期発注商品",
    ArrivalState: "入荷状況",
    SafetyStock: "減少在庫",
    PersonalStay: "滞留社員",
    Training: "教育・研修受講実績",
    Training2: "教育・研修未受講者",
    HealthCheck: "健康診断",
    Age: "年齢",
    Qualification: "資格更新",
    Retire: "退職管理",
    WorkContract: "労働契約更新",
    Leave: "休職者",
    Passport: "ビザ・パスポート管理",
    SummaryGroup: "部門サマリ情報",
    SummaryQualification: "資格サマリ情報",
    SummaryRetire: "退職サマリ情報",
    SummaryPerson: "社員サマリ情報",
    Family: "家族年齢",
    SecondedTo: "出向履歴情報",
    SecondedFrom: "出向受入履歴情報",
    // ChangePersonalData: "社員情報変更通知",
    Free: "自由通知",
};
/** レコメンドの説明 */
exports.NOTICE_DESCRIBE = {
    /** 仕入先ランク */
    SupplierRank: "月と年別に、仕入取引金額が大きい仕入先情報をアラートします。",
    /** 得意先ランク */
    ClientRank: "月と年別に、受注取引金額が大きい得意先情報をアラートします。",
    /** 担当者ランク */
    StaffRank: "月と年別に、担当者毎の受注取引金額が大きい得意先情報をアラートします。",
    /** 受注状況 */
    OrderState: "受注した商品と得意先の情報をアラートします。",
    /** 納品状況 */
    DeliveryState: "納品期日を越えて納品していない受注伝票をアラートします。",
    /** 滞留債権 */
    PastDue: "回収予定日を過ぎている未回収の債権をアラートします。",
    /** 関連商品 */
    RelatedItem: "受注時によく一緒に注文されている商品をアラートします。",
    /** 納期状況 */
    TimeOfDelivery: "受注した商品の出荷予定日と納期期日をアラートします。",
    /** 一定回数受注商品 */
    SomeTimesItem: "一定回数受注した商品から、しばらく受注がない商品をアラートします。",
    /** 定期受注商品 */
    IntervalItem: "最終受注日から一定期間受注がない商品をアラートします。",
    /** 時期受注商品 */
    SeasonItem: "指定時期に受注する予定の商品から、受注がない商品をアラートします。",
    /** 類似得意先（商品） */
    SimilarItem: "同じ商品を受注している得意先を抽出し、その得意先が受注している他の商品をアラートします。",
    /** 類似得意先（商品区分） */
    SimilarItem2: "同じ商品区分の商品を受注している得意先を抽出し、その得意先が受注している他の商品区分をアラートします。",
    /** 新着商品 */
    NewItem: "新しく登録された商品をアラートします。",
    /** 新規得意先 */
    NewClient: "新しく登録された得意先をアラートします。",
    /** 新規仕入先 */
    NewSupplier: "新しく登録された仕入先をアラートします。",
    /** 休眠顧客 */
    DormantClient: "一定期間受注がない得意先をアラートします。",
    /** 滞留在庫 */
    RetainedStock: "一定期間受注がない在庫をアラートします。",
    /** 在庫状況（受注商品） */
    StockState: "一定期間内に受注した商品の在庫状況をアラートします。",
    /** 在庫状況（商品） */
    StockState2: "指定した商品の在庫状況をアラートします。",
    /** 在庫状況（商品区分） */
    StockState3: "指定した商品区分の商品の在庫状況をアラートします。",
    /** 時期発注商品 */
    SeasonOrder: "指定時期に発注する予定の商品から、発注していない商品をアラートします。",
    /** 入荷状況 */
    ArrivalState: "入荷予定日を越えて入荷していない発注伝票をアラートします。",
    /** 減少在庫 */
    SafetyStock: "発注点に近づいた商品の在庫数をアラートします。",
    // 総務人事
    /** 滞留社員通知 */
    PersonalStay: "所属や勤務地などが一定期間同じ社員をアラートします。",
    /** 教育・研修受講実績 */
    Training: "教育・研修の受講者を一覧にしてアラートします。",
    /** 教育・研修未受講者 */
    Training2: "教育・研修の未受講者を一覧にしてアラートします。",
    /** 健康診断 */
    HealthCheck: "指定期間の健康診断のデータがない対象者をアラートします。",
    /** 年齢 */
    Age: "社員情報から指定した年齢の社員をアラートします。",
    /** 資格更新 */
    Qualification: "社員の免許・資格の有効期限が近づいたらアラートします。",
    /** 退職管理 */
    Retire: "社員の退職予定日が近づいたらアラートします。",
    /** 労働契約更新 */
    WorkContract: "社員の労働契約満了日が近づいたらアラートします。",
    /** 休職者 */
    Leave: "社員の休職終了予定日が近づいたらアラートします。",
    /** ビザ・パスポート管理 */
    Passport: "社員の在留期限またはパスポートの有効期限が近づいたらアラートします。",
    /** 部門サマリ情報 */
    SummaryGroup: "部門ごとの人数や平均年齢をまとめてアラートします。",
    /** 資格サマリ情報 */
    SummaryQualification: "資格ごとの保有人数をまとめてアラートします。",
    /** 退職サマリ情報 */
    SummaryRetire: "退職者についての情報をまとめてアラートします。",
    /** 社員サマリ情報 */
    SummaryPerson: "社員の人数情報をまとめてアラートします。",
    /** 家族年齢 */
    Family: "社員の家族情報から指定した年齢の家族をアラートします。",
    /** 出向履歴情報 */
    SecondedTo: "社員の出向終了予定日が近づいたらアラートします。",
    /** 出向受入履歴情報 */
    SecondedFrom: "受入終了予定日が近づいたらアラートします。",
    /** 社員情報変更通知 */
    // ChangePersonalData: "社員情報に変更があった場合にアラートします。",
    /** 自由通知 */
    Free: "通知内容とタイミングを自由に指定してアラートします。",
};
/** レコメンドのURL */
exports.NOTICE_URL = {
    SupplierRank: "/supplierRank",
    ClientRank: "/clientrank",
    StaffRank: "/staffrank",
    OrderState: "/orderstate",
    DeliveryState: "/deliverystate",
    PastDue: "/pastdue",
    RelatedItem: "/relateditem",
    TimeOfDelivery: "/alerttimeofdelivery",
    SomeTimesItem: "/sometimesitem",
    IntervalItem: "/intervalitem",
    SeasonItem: "/seasonitem",
    SimilarItem: "/similaritem",
    SimilarItem2: "/similaritem2",
    NewItem: "/alertnewitem",
    NewClient: "/alertnewclient",
    NewSupplier: "/alertnewsupplier",
    DormantClient: "/dormantclient",
    RetainedStock: "/retainedstock",
    StockState: "/stockstate",
    StockState2: "/stockState2",
    StockState3: "/stockState3",
    SeasonOrder: "/seasonorder",
    ArrivalState: "/arrivalstate",
    SafetyStock: "/safetystock",
    PersonalStay: "/personalstay",
    Training: "/training",
    Training2: "/training2",
    HealthCheck: "/healthcheck",
    Age: "/age",
    Qualification: "/qualification",
    Retire: "/retire",
    WorkContract: "/workcontract",
    Leave: "/leave",
    Passport: "/passport",
    SummaryGroup: "/summarygroup",
    SummaryQualification: "/summaryqualification",
    SummaryRetire: "/summaryretire",
    SummaryPerson: "/summaryperson",
    Family: "/family",
    SecondedTo: "/secondedto",
    SecondedFrom: "/secondedfrom",
    // ChangePersonalData: "/changepersonaldata",
    Free: "/free",
};
exports.NOTICE_METHOD_TYPE = {
    Mail: 1,
    Chatwork: 2,
    Slack: 3,
    Line: 4,
    Teams: 5,
    Lineworks: 6,
};
/** 通知ルール */
exports.NOTICE_RULE = {
    WEBHOOK: 1,
    REGULAR: 2,
    MANUAL: 9,
};
/** 通知タイミング */
exports.NOTICE_TIMING = {
    MONTH: 1,
    WEEK: 2,
    DAY: 3,
    HOUR: 4,
};
/**
 * サービスタイプ
 * @example
 * service & SERVICE_TYPE.SALES
 */
exports.SERVICE_TYPE = {
    SALES: 1,
    STOCK: 2,
    GENERAL: 4,
    OTHER: 0,
};
/**
 * 通知オプション
 */
exports.VIEW_OPTION = {
    TEXT: 1,
    GRAPH: 2,
};
/**
 * レコメンドが使える機能
 * 複数機能必要な場合Andを取る
 * 複数機能のうちのどれかが必要な場合ビットを反転して排他的を取ってAnd
 */
exports.NOTICE_SERVICE = {
    SupplierRank: exports.SERVICE_TYPE.STOCK,
    ClientRank: exports.SERVICE_TYPE.SALES,
    StaffRank: exports.SERVICE_TYPE.SALES,
    OrderState: exports.SERVICE_TYPE.SALES,
    DeliveryState: exports.SERVICE_TYPE.SALES,
    PastDue: exports.SERVICE_TYPE.SALES,
    RelatedItem: exports.SERVICE_TYPE.SALES,
    TimeOfDelivery: exports.SERVICE_TYPE.SALES,
    SomeTimesItem: exports.SERVICE_TYPE.SALES,
    IntervalItem: exports.SERVICE_TYPE.SALES,
    SeasonItem: exports.SERVICE_TYPE.SALES,
    SimilarItem: exports.SERVICE_TYPE.SALES,
    SimilarItem2: exports.SERVICE_TYPE.SALES,
    NewItem: ~(exports.SERVICE_TYPE.SALES + exports.SERVICE_TYPE.STOCK),
    NewClient: ~(exports.SERVICE_TYPE.SALES + exports.SERVICE_TYPE.STOCK),
    NewSupplier: exports.SERVICE_TYPE.STOCK,
    DormantClient: exports.SERVICE_TYPE.SALES,
    RetainedStock: exports.SERVICE_TYPE.SALES + exports.SERVICE_TYPE.STOCK,
    StockState: exports.SERVICE_TYPE.SALES + exports.SERVICE_TYPE.STOCK,
    StockState2: exports.SERVICE_TYPE.STOCK,
    StockState3: exports.SERVICE_TYPE.STOCK,
    SeasonOrder: exports.SERVICE_TYPE.STOCK,
    ArrivalState: exports.SERVICE_TYPE.STOCK,
    SafetyStock: exports.SERVICE_TYPE.STOCK,
    PersonalStay: exports.SERVICE_TYPE.GENERAL,
    Training: exports.SERVICE_TYPE.GENERAL,
    Training2: exports.SERVICE_TYPE.GENERAL,
    HealthCheck: exports.SERVICE_TYPE.GENERAL,
    Age: exports.SERVICE_TYPE.GENERAL,
    Qualification: exports.SERVICE_TYPE.GENERAL,
    Retire: exports.SERVICE_TYPE.GENERAL,
    WorkContract: exports.SERVICE_TYPE.GENERAL,
    Leave: exports.SERVICE_TYPE.GENERAL,
    Passport: exports.SERVICE_TYPE.GENERAL,
    SummaryGroup: exports.SERVICE_TYPE.GENERAL,
    SummaryQualification: exports.SERVICE_TYPE.GENERAL,
    SummaryRetire: exports.SERVICE_TYPE.GENERAL,
    SummaryPerson: exports.SERVICE_TYPE.GENERAL,
    Family: exports.SERVICE_TYPE.GENERAL,
    SecondedTo: exports.SERVICE_TYPE.GENERAL,
    SecondedFrom: exports.SERVICE_TYPE.GENERAL,
    // ChangePersonalData: SERVICE_TYPE.GENERAL,
    Free: exports.SERVICE_TYPE.OTHER,
};
/**
 * メニュー表示用
 * menuGroup: グループ 1:経営、2:販促、3:在庫 4:労務
 * service: 契約対象
 * url 遷移先URL
 * title 表示テキスト
 */
exports.MENU_MAP = [
    { menuGroup: 1, type: exports.NOTICE_TYPE.SupplierRank, service: exports.NOTICE_SERVICE.SupplierRank, url: exports.NOTICE_URL.SupplierRank, title: exports.NOTICE_NAME.SupplierRank },
    { menuGroup: 1, type: exports.NOTICE_TYPE.ClientRank, service: exports.NOTICE_SERVICE.ClientRank, url: exports.NOTICE_URL.ClientRank, title: exports.NOTICE_NAME.ClientRank },
    { menuGroup: 1, type: exports.NOTICE_TYPE.StaffRank, service: exports.NOTICE_SERVICE.StaffRank, url: exports.NOTICE_URL.StaffRank, title: exports.NOTICE_NAME.StaffRank },
    { menuGroup: 1, type: exports.NOTICE_TYPE.OrderState, service: exports.NOTICE_SERVICE.OrderState, url: exports.NOTICE_URL.OrderState, title: exports.NOTICE_NAME.OrderState },
    { menuGroup: 1, type: exports.NOTICE_TYPE.DeliveryState, service: exports.NOTICE_SERVICE.DeliveryState, url: exports.NOTICE_URL.DeliveryState, title: exports.NOTICE_NAME.DeliveryState },
    { menuGroup: 1, type: exports.NOTICE_TYPE.PastDue, service: exports.NOTICE_SERVICE.PastDue, url: exports.NOTICE_URL.PastDue, title: exports.NOTICE_NAME.PastDue },
    { menuGroup: 1, type: exports.NOTICE_TYPE.SummaryGroup, service: exports.NOTICE_SERVICE.SummaryGroup, url: exports.NOTICE_URL.SummaryGroup, title: exports.NOTICE_NAME.SummaryGroup },
    { menuGroup: 1, type: exports.NOTICE_TYPE.SummaryQualification, service: exports.NOTICE_SERVICE.SummaryQualification, url: exports.NOTICE_URL.SummaryQualification, title: exports.NOTICE_NAME.SummaryQualification },
    { menuGroup: 1, type: exports.NOTICE_TYPE.SummaryRetire, service: exports.NOTICE_SERVICE.SummaryRetire, url: exports.NOTICE_URL.SummaryRetire, title: exports.NOTICE_NAME.SummaryRetire },
    { menuGroup: 1, type: exports.NOTICE_TYPE.SummaryPerson, service: exports.NOTICE_SERVICE.SummaryPerson, url: exports.NOTICE_URL.SummaryPerson, title: exports.NOTICE_NAME.SummaryPerson },
    { menuGroup: 2, type: exports.NOTICE_TYPE.RelatedItem, service: exports.NOTICE_SERVICE.RelatedItem, url: exports.NOTICE_URL.RelatedItem, title: exports.NOTICE_NAME.RelatedItem },
    { menuGroup: 2, type: exports.NOTICE_TYPE.TimeOfDelivery, service: exports.NOTICE_SERVICE.TimeOfDelivery, url: exports.NOTICE_URL.TimeOfDelivery, title: exports.NOTICE_NAME.TimeOfDelivery },
    { menuGroup: 2, type: exports.NOTICE_TYPE.SomeTimesItem, service: exports.NOTICE_SERVICE.SomeTimesItem, url: exports.NOTICE_URL.SomeTimesItem, title: exports.NOTICE_NAME.SomeTimesItem },
    { menuGroup: 2, type: exports.NOTICE_TYPE.IntervalItem, service: exports.NOTICE_SERVICE.IntervalItem, url: exports.NOTICE_URL.IntervalItem, title: exports.NOTICE_NAME.IntervalItem },
    { menuGroup: 2, type: exports.NOTICE_TYPE.SeasonItem, service: exports.NOTICE_SERVICE.SeasonItem, url: exports.NOTICE_URL.SeasonItem, title: exports.NOTICE_NAME.SeasonItem },
    { menuGroup: 2, type: exports.NOTICE_TYPE.SimilarItem, service: exports.NOTICE_SERVICE.SimilarItem, url: exports.NOTICE_URL.SimilarItem, title: exports.NOTICE_NAME.SimilarItem },
    { menuGroup: 2, type: exports.NOTICE_TYPE.SimilarItem2, service: exports.NOTICE_SERVICE.SimilarItem2, url: exports.NOTICE_URL.SimilarItem2, title: exports.NOTICE_NAME.SimilarItem2 },
    { menuGroup: 2, type: exports.NOTICE_TYPE.NewItem, service: exports.NOTICE_SERVICE.NewItem, url: exports.NOTICE_URL.NewItem, title: exports.NOTICE_NAME.NewItem },
    { menuGroup: 2, type: exports.NOTICE_TYPE.NewClient, service: exports.NOTICE_SERVICE.NewClient, url: exports.NOTICE_URL.NewClient, title: exports.NOTICE_NAME.NewClient },
    { menuGroup: 2, type: exports.NOTICE_TYPE.NewSupplier, service: exports.NOTICE_SERVICE.NewSupplier, url: exports.NOTICE_URL.NewSupplier, title: exports.NOTICE_NAME.NewSupplier },
    { menuGroup: 2, type: exports.NOTICE_TYPE.DormantClient, service: exports.NOTICE_SERVICE.DormantClient, url: exports.NOTICE_URL.DormantClient, title: exports.NOTICE_NAME.DormantClient },
    { menuGroup: 3, type: exports.NOTICE_TYPE.RetainedStock, service: exports.NOTICE_SERVICE.RetainedStock, url: exports.NOTICE_URL.RetainedStock, title: exports.NOTICE_NAME.RetainedStock },
    { menuGroup: 3, type: exports.NOTICE_TYPE.StockState, service: exports.NOTICE_SERVICE.StockState, url: exports.NOTICE_URL.StockState, title: exports.NOTICE_NAME.StockState },
    { menuGroup: 3, type: exports.NOTICE_TYPE.StockState2, service: exports.NOTICE_SERVICE.StockState2, url: exports.NOTICE_URL.StockState2, title: exports.NOTICE_NAME.StockState2 },
    { menuGroup: 3, type: exports.NOTICE_TYPE.StockState3, service: exports.NOTICE_SERVICE.StockState3, url: exports.NOTICE_URL.StockState3, title: exports.NOTICE_NAME.StockState3 },
    { menuGroup: 3, type: exports.NOTICE_TYPE.SeasonOrder, service: exports.NOTICE_SERVICE.SeasonOrder, url: exports.NOTICE_URL.SeasonOrder, title: exports.NOTICE_NAME.SeasonOrder },
    { menuGroup: 3, type: exports.NOTICE_TYPE.ArrivalState, service: exports.NOTICE_SERVICE.ArrivalState, url: exports.NOTICE_URL.ArrivalState, title: exports.NOTICE_NAME.ArrivalState },
    { menuGroup: 3, type: exports.NOTICE_TYPE.SafetyStock, service: exports.NOTICE_SERVICE.SafetyStock, url: exports.NOTICE_URL.SafetyStock, title: exports.NOTICE_NAME.SafetyStock },
    { menuGroup: 4, type: exports.NOTICE_TYPE.PersonalStay, service: exports.NOTICE_SERVICE.PersonalStay, url: exports.NOTICE_URL.PersonalStay, title: exports.NOTICE_NAME.PersonalStay },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Training, service: exports.NOTICE_SERVICE.Training, url: exports.NOTICE_URL.Training, title: exports.NOTICE_NAME.Training },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Training2, service: exports.NOTICE_SERVICE.Training2, url: exports.NOTICE_URL.Training2, title: exports.NOTICE_NAME.Training2 },
    // { menuGroup: 4, type: NOTICE_TYPE.HealthCheck, service: NOTICE_SERVICE.HealthCheck, url: NOTICE_URL.HealthCheck, title: NOTICE_NAME.HealthCheck },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Age, service: exports.NOTICE_SERVICE.Age, url: exports.NOTICE_URL.Age, title: exports.NOTICE_NAME.Age },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Qualification, service: exports.NOTICE_SERVICE.Qualification, url: exports.NOTICE_URL.Qualification, title: exports.NOTICE_NAME.Qualification },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Retire, service: exports.NOTICE_SERVICE.Retire, url: exports.NOTICE_URL.Retire, title: exports.NOTICE_NAME.Retire },
    { menuGroup: 4, type: exports.NOTICE_TYPE.WorkContract, service: exports.NOTICE_SERVICE.WorkContract, url: exports.NOTICE_URL.WorkContract, title: exports.NOTICE_NAME.WorkContract },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Leave, service: exports.NOTICE_SERVICE.Leave, url: exports.NOTICE_URL.Leave, title: exports.NOTICE_NAME.Leave },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Passport, service: exports.NOTICE_SERVICE.Passport, url: exports.NOTICE_URL.Passport, title: exports.NOTICE_NAME.Passport },
    { menuGroup: 4, type: exports.NOTICE_TYPE.Family, service: exports.NOTICE_SERVICE.Family, url: exports.NOTICE_URL.Family, title: exports.NOTICE_NAME.Family },
    { menuGroup: 4, type: exports.NOTICE_TYPE.SecondedTo, service: exports.NOTICE_SERVICE.SecondedTo, url: exports.NOTICE_URL.SecondedTo, title: exports.NOTICE_NAME.SecondedTo },
    { menuGroup: 4, type: exports.NOTICE_TYPE.SecondedFrom, service: exports.NOTICE_SERVICE.SecondedFrom, url: exports.NOTICE_URL.SecondedFrom, title: exports.NOTICE_NAME.SecondedFrom },
    // { menuGroup: 4, type: NOTICE_TYPE.ChangePersonalData, service: NOTICE_SERVICE.ChangePersonalData, url: NOTICE_URL.ChangePersonalData, title: NOTICE_NAME.ChangePersonalData },
    { menuGroup: 99, type: exports.NOTICE_TYPE.Free, service: exports.NOTICE_SERVICE.Free, url: exports.NOTICE_URL.Free, title: exports.NOTICE_NAME.Free },
];
/**
 * サービスに対応するするショートネームをhtmlで取得（色付き）
 * @param service
 * @returns html
 */
exports.SERVICE_NAME_HTML_MAP = function (service) {
    switch (service) {
        case -4:
            return "<b style='color: rgba(63, 142, 74, 1.0)'>商</b>/<b style='color: rgba(113, 173, 70, 1.0)'>蔵</b>";
            break;
        case 1:
            return "<b style='color: rgba(63, 142, 74, 1.0)'>商</b>";
            break;
        case 2:
            return "<b style='color: rgba(113, 173, 70, 1.0)'>蔵</b>";
            break;
        case 3:
            return "<b style='color: rgba(63, 142, 74, 1.0)'>商</b><b style='color: rgba(113, 173, 70, 1.0)'>蔵</b>";
            break;
        case 4:
            return "<b style='color: rgba(2, 123, 145, 1.0)'>総</b>";
            break;
        case 0:
            return "<b style='color: rgba(63, 63, 63, 1.0)'>他</b>";
            break;
        default:
            return "";
    }
};
/**
 * 定数一覧
 * import { Const } from "./../utils/Const"
 * Const.getInstance()
 */
var Const = /** @class */ (function () {
    /** new 禁止 */
    function Const() {
        this.noticeMap = {};
    }
    /** 初期化 */
    Const.getInstance = function () {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new Const();
        // const KURA = "<b style='color: rgba(113, 173, 70, 1.0)'>蔵</b>"
        // const AKINAI = "<b style='color: rgba(63, 142, 74, 1.0)'>商</b>"
        this.instance.noticeMap[exports.NOTICE_TYPE.SupplierRank] = {
            name: exports.NOTICE_NAME.SupplierRank,
            remark: exports.NOTICE_DESCRIBE.SupplierRank,
            url: exports.NOTICE_URL.SupplierRank,
            service: exports.NOTICE_SERVICE.SupplierRank,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.ClientRank] = {
            name: exports.NOTICE_NAME.ClientRank,
            remark: exports.NOTICE_DESCRIBE.ClientRank,
            url: exports.NOTICE_URL.ClientRank,
            service: exports.NOTICE_SERVICE.ClientRank,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.StaffRank] = {
            name: exports.NOTICE_NAME.StaffRank,
            remark: exports.NOTICE_DESCRIBE.StaffRank,
            url: exports.NOTICE_URL.StaffRank,
            service: exports.NOTICE_SERVICE.StaffRank,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.OrderState] = {
            name: exports.NOTICE_NAME.OrderState,
            remark: exports.NOTICE_DESCRIBE.OrderState,
            url: exports.NOTICE_URL.OrderState,
            service: exports.NOTICE_SERVICE.OrderState,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.DeliveryState] = {
            name: exports.NOTICE_NAME.DeliveryState,
            remark: exports.NOTICE_DESCRIBE.DeliveryState,
            url: exports.NOTICE_URL.DeliveryState,
            service: exports.NOTICE_SERVICE.DeliveryState,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.PastDue] = {
            name: exports.NOTICE_NAME.PastDue,
            remark: exports.NOTICE_DESCRIBE.PastDue,
            url: exports.NOTICE_URL.PastDue,
            service: exports.NOTICE_SERVICE.PastDue,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.RelatedItem] = {
            name: exports.NOTICE_NAME.RelatedItem,
            remark: exports.NOTICE_DESCRIBE.RelatedItem,
            url: exports.NOTICE_URL.RelatedItem,
            service: exports.NOTICE_SERVICE.RelatedItem,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.TimeOfDelivery] = {
            name: exports.NOTICE_NAME.TimeOfDelivery,
            remark: exports.NOTICE_DESCRIBE.TimeOfDelivery,
            url: exports.NOTICE_URL.TimeOfDelivery,
            service: exports.NOTICE_SERVICE.TimeOfDelivery,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SomeTimesItem] = {
            name: exports.NOTICE_NAME.SomeTimesItem,
            remark: exports.NOTICE_DESCRIBE.SomeTimesItem,
            url: exports.NOTICE_URL.SomeTimesItem,
            service: exports.NOTICE_SERVICE.SomeTimesItem,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.IntervalItem] = {
            name: exports.NOTICE_NAME.IntervalItem,
            remark: exports.NOTICE_DESCRIBE.IntervalItem,
            url: exports.NOTICE_URL.IntervalItem,
            service: exports.NOTICE_SERVICE.IntervalItem,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SeasonItem] = {
            name: exports.NOTICE_NAME.SeasonItem,
            remark: exports.NOTICE_DESCRIBE.SeasonItem,
            url: exports.NOTICE_URL.SeasonItem,
            service: exports.NOTICE_SERVICE.SeasonItem,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SimilarItem] = {
            name: exports.NOTICE_NAME.SimilarItem,
            remark: exports.NOTICE_DESCRIBE.SimilarItem,
            url: exports.NOTICE_URL.SimilarItem,
            service: exports.NOTICE_SERVICE.SimilarItem,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SimilarItem2] = {
            name: exports.NOTICE_NAME.SimilarItem2,
            remark: exports.NOTICE_DESCRIBE.SimilarItem2,
            url: exports.NOTICE_URL.SimilarItem2,
            service: exports.NOTICE_SERVICE.SimilarItem2,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.NewItem] = {
            name: exports.NOTICE_NAME.NewItem,
            remark: exports.NOTICE_DESCRIBE.NewItem,
            url: exports.NOTICE_URL.NewItem,
            service: exports.NOTICE_SERVICE.NewItem,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.NewClient] = {
            name: exports.NOTICE_NAME.NewClient,
            remark: exports.NOTICE_DESCRIBE.NewClient,
            url: exports.NOTICE_URL.NewClient,
            service: exports.NOTICE_SERVICE.NewClient,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.NewSupplier] = {
            name: exports.NOTICE_NAME.NewSupplier,
            remark: exports.NOTICE_DESCRIBE.NewSupplier,
            url: exports.NOTICE_URL.NewSupplier,
            service: exports.NOTICE_SERVICE.NewSupplier,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.DormantClient] = {
            name: exports.NOTICE_NAME.DormantClient,
            remark: exports.NOTICE_DESCRIBE.DormantClient,
            url: exports.NOTICE_URL.DormantClient,
            service: exports.NOTICE_SERVICE.DormantClient,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.RetainedStock] = {
            name: exports.NOTICE_NAME.RetainedStock,
            remark: exports.NOTICE_DESCRIBE.RetainedStock,
            url: exports.NOTICE_URL.RetainedStock,
            service: exports.NOTICE_SERVICE.RetainedStock,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.StockState] = {
            name: exports.NOTICE_NAME.StockState,
            remark: exports.NOTICE_DESCRIBE.StockState,
            url: exports.NOTICE_URL.StockState,
            service: exports.NOTICE_SERVICE.StockState,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.StockState2] = {
            name: exports.NOTICE_NAME.StockState2,
            remark: exports.NOTICE_DESCRIBE.StockState2,
            url: exports.NOTICE_URL.StockState2,
            service: exports.NOTICE_SERVICE.StockState2,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.StockState3] = {
            name: exports.NOTICE_NAME.StockState3,
            remark: exports.NOTICE_DESCRIBE.StockState3,
            url: exports.NOTICE_URL.StockState3,
            service: exports.NOTICE_SERVICE.StockState3,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SeasonOrder] = {
            name: exports.NOTICE_NAME.SeasonOrder,
            remark: exports.NOTICE_DESCRIBE.SeasonOrder,
            url: exports.NOTICE_URL.SeasonOrder,
            service: exports.NOTICE_SERVICE.SeasonOrder,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.ArrivalState] = {
            name: exports.NOTICE_NAME.ArrivalState,
            remark: exports.NOTICE_DESCRIBE.ArrivalState,
            url: exports.NOTICE_URL.ArrivalState,
            service: exports.NOTICE_SERVICE.ArrivalState,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SafetyStock] = {
            name: exports.NOTICE_NAME.SafetyStock,
            remark: exports.NOTICE_DESCRIBE.SafetyStock,
            url: exports.NOTICE_URL.SafetyStock,
            service: exports.NOTICE_SERVICE.SafetyStock,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.PersonalStay] = {
            name: exports.NOTICE_NAME.PersonalStay,
            remark: exports.NOTICE_DESCRIBE.PersonalStay,
            url: exports.NOTICE_URL.PersonalStay,
            service: exports.NOTICE_SERVICE.PersonalStay,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Training] = {
            name: exports.NOTICE_NAME.Training,
            remark: exports.NOTICE_DESCRIBE.Training,
            url: exports.NOTICE_URL.Training,
            service: exports.NOTICE_SERVICE.Training,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Training2] = {
            name: exports.NOTICE_NAME.Training2,
            remark: exports.NOTICE_DESCRIBE.Training2,
            url: exports.NOTICE_URL.Training2,
            service: exports.NOTICE_SERVICE.Training2,
        };
        // this.instance.noticeMap[NOTICE_TYPE.HealthCheck] = {
        //   name: NOTICE_NAME.HealthCheck,
        //   remark: NOTICE_DESCRIBE.HealthCheck,
        //   url: NOTICE_URL.HealthCheck,
        //   service: NOTICE_SERVICE.HealthCheck,
        // }
        this.instance.noticeMap[exports.NOTICE_TYPE.Age] = {
            name: exports.NOTICE_NAME.Age,
            remark: exports.NOTICE_DESCRIBE.Age,
            url: exports.NOTICE_URL.Age,
            service: exports.NOTICE_SERVICE.Age,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Qualification] = {
            name: exports.NOTICE_NAME.Qualification,
            remark: exports.NOTICE_DESCRIBE.Qualification,
            url: exports.NOTICE_URL.Qualification,
            service: exports.NOTICE_SERVICE.Qualification,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Retire] = {
            name: exports.NOTICE_NAME.Retire,
            remark: exports.NOTICE_DESCRIBE.Retire,
            url: exports.NOTICE_URL.Retire,
            service: exports.NOTICE_SERVICE.Retire,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.WorkContract] = {
            name: exports.NOTICE_NAME.WorkContract,
            remark: exports.NOTICE_DESCRIBE.WorkContract,
            url: exports.NOTICE_URL.WorkContract,
            service: exports.NOTICE_SERVICE.WorkContract,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Leave] = {
            name: exports.NOTICE_NAME.Leave,
            remark: exports.NOTICE_DESCRIBE.Leave,
            url: exports.NOTICE_URL.Leave,
            service: exports.NOTICE_SERVICE.Leave,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Passport] = {
            name: exports.NOTICE_NAME.Passport,
            remark: exports.NOTICE_DESCRIBE.Passport,
            url: exports.NOTICE_URL.Passport,
            service: exports.NOTICE_SERVICE.Passport,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SummaryGroup] = {
            name: exports.NOTICE_NAME.SummaryGroup,
            remark: exports.NOTICE_DESCRIBE.SummaryGroup,
            url: exports.NOTICE_URL.SummaryGroup,
            service: exports.NOTICE_SERVICE.SummaryGroup,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SummaryQualification] = {
            name: exports.NOTICE_NAME.SummaryQualification,
            remark: exports.NOTICE_DESCRIBE.SummaryQualification,
            url: exports.NOTICE_URL.SummaryQualification,
            service: exports.NOTICE_SERVICE.SummaryQualification,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SummaryRetire] = {
            name: exports.NOTICE_NAME.SummaryRetire,
            remark: exports.NOTICE_DESCRIBE.SummaryRetire,
            url: exports.NOTICE_URL.SummaryRetire,
            service: exports.NOTICE_SERVICE.SummaryRetire,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SummaryPerson] = {
            name: exports.NOTICE_NAME.SummaryPerson,
            remark: exports.NOTICE_DESCRIBE.SummaryPerson,
            url: exports.NOTICE_URL.SummaryPerson,
            service: exports.NOTICE_SERVICE.SummaryPerson,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.Family] = {
            name: exports.NOTICE_NAME.Family,
            remark: exports.NOTICE_DESCRIBE.Family,
            url: exports.NOTICE_URL.Family,
            service: exports.NOTICE_SERVICE.Family,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SecondedTo] = {
            name: exports.NOTICE_NAME.SecondedTo,
            remark: exports.NOTICE_DESCRIBE.SecondedTo,
            url: exports.NOTICE_URL.SecondedTo,
            service: exports.NOTICE_SERVICE.SecondedTo,
        };
        this.instance.noticeMap[exports.NOTICE_TYPE.SecondedFrom] = {
            name: exports.NOTICE_NAME.SecondedFrom,
            remark: exports.NOTICE_DESCRIBE.SecondedFrom,
            url: exports.NOTICE_URL.SecondedFrom,
            service: exports.NOTICE_SERVICE.SecondedFrom,
        };
        // this.instance.noticeMap[NOTICE_TYPE.ChangePersonalData] = {
        //   name: NOTICE_NAME.ChangePersonalData,
        //   remark: NOTICE_DESCRIBE.ChangePersonalData,
        //   url: NOTICE_URL.ChangePersonalData,
        //   service: NOTICE_SERVICE.ChangePersonalData,
        // }
        this.instance.noticeMap[exports.NOTICE_TYPE.Free] = {
            name: exports.NOTICE_NAME.Free,
            remark: exports.NOTICE_DESCRIBE.Free,
            url: exports.NOTICE_URL.Free,
            service: exports.NOTICE_SERVICE.Free,
        };
        // this.instance.noticeMap[NOTICE_TYPE.MasterPrice] = {
        //   name: "マスタ価格不一致",
        //   url: "/",
        //   service: SERVICE_TYPE.SALES + SERVICE_TYPE.STOCK,
        //   remark: "アラートします。",
        // }
        return this.instance;
    };
    Const.prototype.getNotice = function (key) { return this.noticeMap[key]; };
    return Const;
}());
exports.Const = Const;
//# sourceMappingURL=Const.js.map